import { render, staticRenderFns } from "./itemsList.vue?vue&type=template&id=8daffe66&scoped=true&"
import script from "./itemsList.vue?vue&type=script&lang=js&"
export * from "./itemsList.vue?vue&type=script&lang=js&"
import style0 from "./itemsList.vue?vue&type=style&index=0&id=8daffe66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daffe66",
  null
  
)

export default component.exports